<template>
  <div>
    <div class="air__utils__heading">
      <h5>Kortingen</h5>
    </div>
    <div class="row">
      <div class="col-xl-12 col-lg-6">
        <div class="card">
          <div class="card-body">
            <discount-list />
          </div>
        </div>

      </div>
      <div class="col-xl-4 col-lg-6">

      </div>
    </div>
  </div>
</template>
<script>
import DiscountList from '@/components/widgets/Discounts/DiscountList'
// import moment from 'moment'
export default {
  components: {
    DiscountList,
  },
}
</script>
